import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';


@Component({
    selector: 'billing-issues-summary-grid-item',
    templateUrl: './billing-issues-summary-grid-item.component.html'
})
export class BillingIssuesSummaryGridItemComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    numberOfConsumerWithIssues: number;
    numberOfIssues: number;
    billingIssuesLastMonth: number;
    issuesVariation: number;
    subscriptions: any[] = [];

    isDecreasing: boolean = false;
    isIncreasing: boolean = false;


    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {

        this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        this.issueService.billingSummary(this.clientId).then((result) => {
            let res = result as any;
            this.numberOfConsumerWithIssues = res.numberofConsumersExperiencingIssues != null ? res.numberofConsumersExperiencingIssues : 0;
            this.numberOfIssues = res.numberOfIssues != null ? res.numberOfIssues : 0;
            this.billingIssuesLastMonth = res.billingIssuesLastMonth != null ? res.billingIssuesLastMonth : 0;
            this.isIncreasing = this.billingIssuesLastMonth > this.numberOfIssues ? true : false;
            this.isDecreasing = this.billingIssuesLastMonth < this.numberOfIssues ? true : false;

            this.issuesVariation = this.billingIssuesLastMonth - this.numberOfIssues;
        }).catch(reason => {
            this.numberOfConsumerWithIssues = 0;
            this.numberOfIssues = 0;
            this.issuesVariation = 0;
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
